// extracted by mini-css-extract-plugin
export default {"paymentElement":"PaymentManagementAddOrEdit_paymentElement__Ao+V8"};